import { render, staticRenderFns } from "./ModalResellerServers.vue?vue&type=template&id=70633c48"
import script from "./ModalResellerServers.vue?vue&type=script&lang=js"
export * from "./ModalResellerServers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports